<template>
  <table class="table is-striped is-fullwidth" v-if="history.length">
    <thead>
      <tr>
        <th>{{$t('form.date')}}</th>
        <th>{{$t('form.order_number')}}</th>
        <th>{{$t('form.amount')}}</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="item in history" :item="item" :key="item.id">
        <td>{{item.created * 1000 | moment}}</td>
        <td>{{item.metadata.order_number}}</td>
        <td>{{item.amount / 100 | currency(item.currency)}}</td>
        <td>
          <a :href="item.receipt_url" target="_blank">
            {{
            $t("form.receipt")
            }}
          </a>
        </td>
      </tr>
    </tbody>
    <tfoot v-if="hasMore">
      <button
        class="button is-primary is-small"
        :class="{'is-loading': historyLoading}"
        @click="loadMore"
      >{{$t('message.load_more')}}</button>
    </tfoot>
  </table>
  <div v-else>{{$t('message.no_data')}}</div>
</template>

<script>
export default {
  async asyncData({ store, params, query, app }) {
    const response = await app.$axios.get(
      `/customer/${params.id}/charges?limit=10`
    );

    return {
      history: response.data.data,
      hasMore: response.data.has_more
    };
  },

  data() {
    return {
      hasMore: false,
      historyLoading: false
    };
  },

  computed: {
    last_id() {
      return this.history.slice(-1)[0].id;
    }
  },

  methods: {
    async loadMore() {
      this.historyLoading = true;
      const { data } = await this.$axios.get(
        `/customer/${this.$route.params.id}/charges?limit=10&starting_after=${this.last_id}`
      );
      this.history = [...this.history, ...data.data];
      this.hasMore = data.has_more;
      this.historyLoading = false;
    }
  }
};
</script>




// WEBPACK FOOTER //
// resources/nuxt/pages/office/users/_id/payments.vue